import validateService from "./validate.service";
const validateId = async (idapp, tokenapp) => {
  let respone = null;
  try {
    const id = idapp;
    const token = tokenapp;
    const body = {
      token: token,
      Id: id ?? "",
    };
    const result = await validateService.getId(body);
    if (result.status === 200) {
      const data = result.data.data;
      localStorage.setItem("idapp", data.Id);
      respone = {
        id: data.Id,
        urlOauth: data.URLOAuth,
        urlApiFamily: data.URLAPIFamily,
        token: data.token,
        accessToken: data.accessToken,
      };
    }
  } catch (error) {
    console.log(error);
  }
  return respone;
};

export { validateId };
